import { render, staticRenderFns } from "./OrganizationPreferences.vue?vue&type=template&id=574e9bb9&scoped=true&"
import script from "./OrganizationPreferences.vue?vue&type=script&lang=js&"
export * from "./OrganizationPreferences.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationPreferences.vue?vue&type=style&index=0&id=574e9bb9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574e9bb9",
  null
  
)

export default component.exports